import {push} from '../lib/history'
import jwtDecode from 'jwt-decode'
import {ORIGIN, axios, auth0} from '../../config'
import {clearCache, refresh} from './page'

const setAxiosToken = token => {
	if(!token) axios.defaults.headers.common['Authorization'] = null
	else axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
let userProfile = null
//let lock = null
let webAuth = null
let tokenRenewalTimeout = 0

const initWebAuth = (cb=null) => {
		import ('auth0-js').then(auth0JsModule => {
   			webAuth = new auth0JsModule.WebAuth({
				domain: 'linuxship.eu.auth0.com',
				clientID: auth0,
				responseType: 'token id_token',
				audience: 'https://linuxship.eu.auth0.com/userinfo',
				scope: 'openid profile roles',
				redirectUri: ORIGIN + '/login'
			})
			//if (window.location.pathname === '/login') handleAuthentication()
			if(cb) cb()
		})
	}

const handleAuthentication = (dispatch=null) => {
		webAuth.parseHash((err, authResult) => {
    		if (authResult && authResult.accessToken && authResult.idToken) {
    			setSession(authResult, dispatch)
				let returnLocation = localStorage.getItem('return_path')
            	if (returnLocation) {
					localStorage.removeItem('return_path')
					push(returnLocation)
				}
				//this.loadAdminInterface()
    		} else if (err) {
        		console.log(err);
    			alert(
        			'Error: ' + err.error + '. Check the console for further details.'
    			);
    		}
    	});
	}
	const renewToken = () => {
		webAuth.checkSession({}, (err, result) => {
    		if (err) {
        		console.log(err);
    		} else {
        		setSession(result);
    		}
    	})
	}
	
	const setSession = (authResult, dispatch=null) => {
		setAxiosToken(authResult.idToken)
		const profile = {
			name: authResult.idTokenPayload.nickname,
			roles: authResult.idTokenPayload['https://linuxship.ro/authorization/roles']
		}
		//this.user = new User(profile)
		const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime())
		localStorage.setItem('expires_at', expiresAt)
		localStorage.setItem('profile', JSON.stringify(profile))
		localStorage.setItem('id_token', authResult.idToken)
		if (dispatch) dispatch(actions.lockSuccess(profile, authResult.idToken))
		scheduleRenewal()
	}
	const scheduleRenewal = () => {
		const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
		const delay = expiresAt - Date.now();
		if (delay > 0) {
    		tokenRenewalTimeout = setTimeout(() => {
    			renewToken();
    		}, delay);
		}
	}

/*
if(typeof(Auth0Lock)!==undefined) {
	try {
		//eslint-disable-next-line
		lock = new Auth0Lock(auth0, 'linuxship.eu.auth0.com', {
  			auth: {
    			redirectUrl: ORIGIN + '/login',
	    		responseType: 'token',
    			params: {
    				scope: 'openid roles'
    			}
	  		}
		})
	} catch (e) {
		console.log(e)
	}
}
*/

const types = {
	AUTHENTICATED: 'AUTHENTICATED',
	SHOW_LOCK: 'SHOW_LOCK',
	LOCK_SUCCESS: 'LOCK_SUCCESS',
	LOCK_ERROR: 'LOCK_ERROR',
	LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
}

const getInitialState = () => {    	
    	let profile = localStorage.getItem('profile')
    	let token = localStorage.getItem('id_token')
    	if(profile && token) {
    		const dtoken = jwtDecode(token)
    		if(dtoken.aud!==auth0 || dtoken.exp < Date.now()/1000) {
				localStorage.removeItem('id_token')
   				localStorage.removeItem('profile')
   			} else {
   				try {
   					profile = JSON.parse(profile)
   					userProfile = profile
   					//this.user = new User(profile)
   					setAxiosToken(token)
			    	scheduleRenewal()
   					//this.loadAdminInterface()
    		return {
        		isFetching: false,
        		isAuthenticating: true,
        		isAuthenticated: false,
        		errorMessage: '',
				isAdmin: false,
				isEditor: false,
        		profile,
        		token
    		}
   				} catch (e) {
   					localStorage.removeItem('id_token')
   					localStorage.removeItem('profile')
   				}
   			}
    	}


	/*
    let profile = localStorage.getItem('profile')
    let token = localStorage.getItem('id_token')
    if(profile && token) {
    	if(jwtDecode(token).exp < Date.now()/1000) {
			localStorage.removeItem('id_token')
    		localStorage.removeItem('profile')
    	} else {
    		profile = JSON.parse(profile)
    		userProfile = profile
    		setAxiosToken(token)
    		
    		return {
        		isFetching: false,
        		isAuthenticating: true,
        		isAuthenticated: false,
        		errorMessage: '',
				isAdmin: false,
				isEditor: false,
        		profile,
        		token
    		}
    	}
    }
    */
    return {
		isFetching: false,
		isAuthenticated: false,
		errorMessage: '',
		profile: null,
		token: null,
		isAdmin: false,
		isEditor: false
    }
}
const initialState = getInitialState()

export default function authReducer(state = initialState, action) {
	switch(action.type) {
		case types.SHOW_LOCK: 
			return Object.assign({}, state, {
        		isFetching: true,
        		isAuthenticated: false,
				isAdmin: false,
				isEditor: false
      		})
      	case types.LOCK_SUCCESS:
      		userProfile = action.profile
      		return Object.assign({}, state, {
        		isFetching: false,
        		isAuthenticating: true,
        		isAuthenticated: false,
        		errorMessage: '',
        		profile: action.profile,
        		token: action.token,
      		})
      	case types.AUTHENTICATED:
      		return Object.assign({}, state, {
        		isFetching: false,
         		isAuthenticating: false,
       			isAuthenticated: true,
        		errorMessage: '',
        		isAdmin: state.profile.roles.includes('admin'),
        		isEditor: state.profile.roles.includes('admin') || state.profile.roles.includes('editor')
      		})
      		
    	case types.LOCK_ERROR:
      		return Object.assign({}, state, {
        		isFetching: false,
        		isAuthenticated: false,
				isAdmin: false,
				isEditor: false,
        		errorMessage: action.message
      		})
    	case types.LOGOUT_SUCCESS:
    		userProfile = null
      		return Object.assign({}, state, {
				isFetching: false,
				isAuthenticated: false,
				errorMessage: '',
				profile: null,
				token: null,
				isAdmin: false,
				isEditor: false
      		})
    	default:
      		return state
	}
}

export const actions = {
	showLock: () => ({type: types.SHOW_LOCK}),
	lockSuccess: (profile, token) => ({type: types.LOCK_SUCCESS, profile, token}),
	lockError: (err) => ({type: types.LOCK_ERROR, err}),
	logoutSuccess: () => ({type: types.LOGOUT_SUCCESS}),
}

export const login = () => (dispatch, getState) => {
            	localStorage.setItem('return_path', document.location.pathname)
            	if (webAuth) webAuth.authorize()
            	else initWebAuth(() => {webAuth.authorize()})
	/*if(!lock) return
	localStorage.setItem('return_path', getState().page.location)
	lock.show()*/
}

export const logout = () => (dispatch, getState) => {
            	if (tokenRenewalTimeout) clearTimeout(tokenRenewalTimeout)
				localStorage.removeItem('id_token')
   				localStorage.removeItem('profile')
   				localStorage.removeItem('expires_at')
   				dispatch(actions.logoutSuccess())
    clearCache()
    dispatch(refresh())
   				//this.context.set({
   				//	user: null,
   				//})
				//this.context.set({themeLoad: false})
	/*localStorage.removeItem('id_token')
   	localStorage.removeItem('profile')
    dispatch(actions.logoutSuccess())
    clearCache()
    dispatch(refresh())*/
}

export const doAuthentication = () => (dispatch, getState) => {
	
	if (window.location.pathname === '/login') {
		if (!webAuth) initWebAuth(() => {handleAuthentication(dispatch)})
		else handleAuthentication(dispatch)
		
	}
	/*
	if(!lock) return
    lock.on("authenticated", function(authResult) {
    	//console.log(authResult)
        lock.getProfile(authResult.idToken, function(error, profile) {
            if (error) {
            	return dispatch(actions.lockError(error))
            }
            setAxiosToken(authResult.idToken)
            localStorage.setItem('profile', JSON.stringify(profile))
            localStorage.setItem('id_token', authResult.idToken)
            dispatch(actions.lockSuccess(profile, authResult.idToken))
			let returnLocation = localStorage.getItem('return_path')
			if (returnLocation) {
				localStorage.removeItem('return_path')
				push(returnLocation)
			}
        });
    });
    */
}

const realAuthenticated = () => ({type: types.AUTHENTICATED})
const authenticated = () => (dispatch, getState) => {
	dispatch(realAuthenticated())
	clearCache()
	dispatch(refresh())
}
const currentUser = () => userProfile
export {authenticated, currentUser}



// WEBPACK FOOTER //
// ./src/fm/reducers/auth.js